import { CONTRACT_PERMISSIONS } from "./PermissionConstant";

export const allowedFilesTypeExtensions = [
  "pdf",
  "txt",
  "docx",
  "xlsx",
  "csv",
  "png",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "m4v",
  "avi",
  "mpg",
  "mp4",
  "m4a",
  "webm",
  "zip",
  "gz",
  "md",
  "ico",
  "vsd",
  "doc",
  "pptx",
  "wav",
  "mp3",
  "ogg",
  "mkv",
  "raw",
  "webm",
  "dwg",
  "vsdx",
  "step",
  "qif",
  "jt",
  "iges",
  "stl",
  "acis",
  "dxf",
  "axm",
  "dc3",
  "tct",
  "tiff",
  "cad",
  "dwfx",
  "iso",
  "isoz",
  "vwx",
  "2d",
  "fcstd",
  "drw",
  "ldr",
];

export const RECORDS_TABLE_HEIGHT = "calc(100vh - 630px)";

export const DEFAULT_LAW_FIRM_ID = 1;
export const DEFAULT_ORG_ID = 1;

export const SIGNED_CONTRACT = ["Contract Document", "Contract sub-documents"];

export const ALLOWED_IMAGE_MIME = {
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".gif": "image/gif",
  ".bmp": "image/bmp",
  ".webp": "image/webp",
};

export const TASK_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  DELAYED: "delayed",
};

export const PARTY_TYPE_OPTIONS = [
  {
    label: "Own",
    value: "own",
  },
  {
    label: "Counter Party",
    value: "counter_party",
  },
];

export const RESCHDULE_TASK_OPTIONS = [
  {
    label: "Revised Schedule",
    value: "revised_schedule",
  },
  {
    label: "Open Ended",
    value: "open_ended",
  },
];

export const YER_NO_RADIO_OPTIONS = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const TRUE_FALSE_RADIO_OPTIONS = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const ACCOUNT_TYPE_OPTIONS = [
  {
    label: "EPC Account",
    value: "epc",
  },
  {
    label: "Employer Account",
    value: "employer",
  },
];

export const DASHBOARD_ROWS_PER_PAGE = 5;

export const FLAG_BUTTON_COLORS = {
  flagged: {
    background: "#ffe9e9",
    border: "#ffe9e9",
    text: "#dc2626",
    icon: "#d4380d",
    hoverBackground: "#ffb3b3",
    hoverBorder: "#ffb3b3",
    hoverText: "#b91c1c",
  },
  resolved: {
    background: "#d4edda",
    border: "#c3e6cb",
    text: "#155724",
    icon: "#155724",
    hoverBackground: "#c3e6cb",
    hoverBorder: "#b1dfbb",
    hoverText: "#0c5460",
  },
};

export const UploadStatus = {
  UPLOADING: "uploading",
  COMPLETED: "completed",
  ERROR: "error",
  CANCELLED: "cancelled",
};
export const CHATBOT_CONFIG = {
  VIEWS: {
    CHAT: "chat",
    HISTORY: "history",
  },
  RECONNECT: {
    MAX_ATTEMPTS: 5,
    DELAY_MULTIPLIER: 1000,
  },
  WEBSOCKET_STATES: {
    CONNECTING: "CONNECTING",
    OPEN: "OPEN",
    CLOSING: "CLOSING",
    CLOSED: "CLOSED",
    DISCONNECTED: "DISCONNECTED",
    UNKNOWN: "UNKNOWN",
  },
};


export const CHATBOT_MESSAGE_TYPE = {
  USER: "user",
  ASSISTENT: "assistant",
};

// export const SUGGESTION_CHIPS = [
//   { id: '1', label: 'Summarize idea', prompt: 'Summarize idea' },
//   { id: '2', label: 'Enhance idea', prompt: 'Enhance idea' },
//   { id: '3', label: 'Explain concept', prompt: 'Explain concept' },
//   { id: '4', label: 'Generate examples', prompt: 'Generate examples' },
//   { id: '5', label: 'Find solutions', prompt: 'Find solutions' },
//   { id: '6', label: 'Create outline', prompt: 'Create outline' },
// ];

export const SUGGESTION_CHIPS = [
  { id: "1", label: "Summarize task", prompt: "Summarize task" },
  { id: "2", label: "Summarize contract", prompt: "Summarize contract" },
  { id: "3", label: "Project brief", prompt: "Project brief" },
  { id: "4", label: "Subtask count", prompt: "Subtask count" },
  { id: "5", label: "Contract end date", prompt: "Contract end date" },
  { id: "6", label: "Open tasks", prompt: "Open tasks" },
];

export const WEBSOCKET_BASE_URL = "/ws/chatbot";

// File upload size limit - 1 GB for all file uploads
export const MAX_DOCUMENT_SIZE = 500 * 1024 * 1024; // 500 MB in bytes

export const DOCUMENT_SIZE_TYPE = "MB";

export const CONTRACT_TYPE = {
  SUB_CONTRACT: "sub_contract",
  MAIN_CONTRACT: "main_contract",
};

// ─────────────────────────────────────────
// PERMISSION CATEGORIES (for role management UI)
// ─────────────────────────────────────────
export const PERMISSION_CATEGORIES = [
  {
    key: "as_signed_contract",
    label: "As Signed Contract",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_SIGNED_CONTRACT, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_SIGNED_CONTRACT, label: "Delete" },
      {
        key: CONTRACT_PERMISSIONS.CAN_DOWNLOAD_SIGNED_CONTRACT,
        label: "Download",
      },
    ],
  },
  {
    key: "repository",
    label: "Repository",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_REPOSITORY, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_CREATE_REPOSITORY, label: "Create" },
      { key: CONTRACT_PERMISSIONS.CAN_DOWNLOAD_REPOSITORY, label: "Download" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_REPOSITORY, label: "Delete" },
    ],
  },
  {
    key: "responsibility_assignments",
    label: "Responsibility Assignments",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_RESPONSIBILITY, label: "View" },
    ],
  },
  {
    key: "obligation",
    label: "Obligation",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_OBLIGATIONS, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_MANAGE_OBLIGATIONS, label: "Manage" },
    ],
  },
  {
    key: "project_schedule",
    label: "Project Schedule",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_PROJECT_SCHEDULE, label: "View" },
      {
        key: CONTRACT_PERMISSIONS.CAN_MANAGE_PROJECT_SCHEDULE,
        label: "Manage",
      },
    ],
  },
  {
    key: "finance_and_payments",
    label: "Finance And Payments",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_FINANCE, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_MANAGE_PAYMENT_FINANCE, label: "Manage" },
    ],
  },
  {
    key: "approvals",
    label: "Approvals",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_APPROVALS, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_CREATE_APPROVALS, label: "Create" },
      { key: CONTRACT_PERMISSIONS.CAN_UPDATE_APPROVALS, label: "Edit" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_APPROVALS, label: "Delete" },
    ],
  },
  {
    key: "negative_covenants",
    label: "Negative Covenants",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_NEGATIVE_COVENANTS, label: "View" },
    ],
  },
  {
    key: "suspension_events",
    label: "Unclassified Events",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_SUSPENSION_EVENTS, label: "View" },
      {
        key: CONTRACT_PERMISSIONS.CAN_CREATE_SUSPENSION_EVENTS,
        label: "Create",
      },
      { key: CONTRACT_PERMISSIONS.CAN_UPDATE_SUSPENSION_EVENTS, label: "Edit" },
      {
        key: CONTRACT_PERMISSIONS.CAN_DELETE_SUSPENSION_EVENTS,
        label: "Delete",
      },
      {
        key: CONTRACT_PERMISSIONS.CAN_DOWNLOAD_SUSPENSION_EVENTS,
        label: "Download",
      },
      {
        key: CONTRACT_PERMISSIONS.CAN_MANAGE_SUSPENSION_EVENT_UPDATE,
        label: "Manage",
      },
    ],
  },
  {
    key: "project_timeline",
    label: "Project Timeline",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_PROJECT_TIMELINE, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_CREATE_PROJECT_TIMELINE, label: "Create" },
      { key: CONTRACT_PERMISSIONS.CAN_EDIT_PROJECT_TIMELINE, label: "Edit" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_PROJECT_TIMELINE, label: "Delete" },
    ],
  },
  {
    key: "reporting_meeting",
    label: "Project Reminders",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_REPORTING_MEETING, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_CREATE_REPORTING_MEETING, label: "Create" },
      { key: CONTRACT_PERMISSIONS.CAN_EDIT_REPORTING_MEETING, label: "Edit" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_REPORTING_MEETING, label: "Delete" },
    ],
  },
  {
    key: "deviations",
    label: "Deviations",
    permissions: [
      { key: CONTRACT_PERMISSIONS.CAN_VIEW_DEVIATIONS, label: "View" },
      { key: CONTRACT_PERMISSIONS.CAN_CREATE_DEVIATIONS, label: "Create" },
      { key: CONTRACT_PERMISSIONS.CAN_EDIT_DEVIATIONS, label: "Edit" },
      { key: CONTRACT_PERMISSIONS.CAN_DELETE_DEVIATIONS, label: "Delete" },
    ],
  },
];

// Permission Modules
export const CONTRACT_PERMISSION_MODULES = {
  SIGNED_CONTRACT: "signed_contract",
  REPOSITORY: "repository",
  RESPONSIBILITY: "responsibility",
  OBLIGATIONS: "obligations",
  PROJECT_SCHEDULE: "project_schedule",
  FINANCE: "finance",
  APPROVALS: "approvals",
  NEGATIVE_COVENANTS: "negativeCovenant",
  SUSPENSION_EVENTS: "suspensionEvents",
  PROJECT_TIMELINE: "projectTimeline",
  REPORTING_MEETING: "reportingMeeting",
  DEVIATIONS: "deviations",
};

// Permission Actions
export const CONTRACT_PERMISSION_ACTIONS = {
  VIEW: "view",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  DOWNLOAD: "download",
  MANAGE_PAYMENT: "manage_payment",
  MANAGE: "manage",
};

export const PROPOSAL_DOCUMENT_NAME = "Deviation Proposal Letter";

export const DEVIATION_PROPOSAL_PARTY = {
  PURCHASER: "purchaser",
  CONTRACTOR: "contractor",
};

export const ADJUSTMENT_TYPES = {
  MATERIAL_SUPPLY: "material_supply",
  WORK_CIVIL: "work_civil",
};

export const DEVIATION_MODAL_MODE = {
  ADD: "add",
  EDIT: "edit",
  VIEW: "view",
};

export const DEVIATION_STATUS = {
  APPROVED: "approved",
  UPDATE_REQUIRED: "update_required",
};

export const DEVIATION_TYPE = {
  PROPOSAL: 1,
  PRICE_ADJUSTMENT: 2,
  CHANGE_OF_SCOPE: 3,
  CHANGE_IN_LAW: 4,
  OTHER: 5,
};

export const DEVIATION_DOCUMENT_CATEGORY = "deviation";
export const FINANCE_DOCUMENT_CATEGORY = "finance";
export const FINANCE_SUPPORTING_DOCUMENT_NAME = "Supporting Document";

export const DEVIATION_DOCUMENT_SLOT = {
  ONE: "one",
  TWO: "two",
};

export const DEVIATION_DOCUMENT_TYPE_KEYWORDS = {
  one: ["document 1", "document_1", "notification"],
  two: ["document 2", "document_2", "price impact"],
};

export const TABS = {
  READ: "read",
  UNREAD: "unread",
  HIGHLIGHTED: "highlighted",
};

export const NOTIFICATION_LIMIT = 5;

